import { TeaserEntry } from '../helper/interfaces'
import React from 'react'

import { AppTheme } from '../helper/enums'
import { getAuthorNames } from '../helper/author'
import { getTeaserTypeIcons, getTeaserImageUrl } from '../helper/images'
import { AdInformationInterface } from '../helper/PageInformationInterface'
import { useLoggedRouter } from '../helper/useLoggedRouter'
import TeaserInfos from './TeaserInfos'
import Image from 'next/image';

export interface TeaserData {
  teaser: TeaserEntry,
  className?: string,
  navigate?: (id?: string, ressortId?: string) => void,
  adInformation?: AdInformationInterface
  ignoreLead?: boolean
}

function TeaserKickerLiveTicker(data: TeaserData) {
  const [routerPush, routerReplace] = useLoggedRouter();

  const internalNavigate = async (e) => {
    e.stopPropagation();
    e.preventDefault();

    if(!data.teaser.id.startsWith("7.")) {
      if (data.navigate) {
        data.navigate(data.teaser.id, undefined)
      }
      else {
        await routerPush(`/article/${encodeURIComponent(data.teaser.id)}`);
      }
    }
  }

  const teaser = data.teaser
  
  const imageHomeUrl = teaser.images?.length > 0 && getTeaserImageUrl(teaser.images[0])+"&width=152";
  const imageAwayUrl = teaser.images?.length > 1 && getTeaserImageUrl(teaser.images[1])+"&width=152";
  
  const teaserClassName = `teaser teaser--type-${teaser.type} teaser--image ${teaser.featured ? 'teaser--featured' : ''} ${data.className ? data.className : ''}`;
  
  let icons = getTeaserTypeIcons(teaser.teaserTypes);
  const authorNames = getAuthorNames(teaser.authors)
  
  return (
    <div data-name={`article-${teaser.id}`}>
      <div>
          <a
            href={`/article/${teaser.id}`}
            key={`teaser-link-${teaser.id}`}
            onClick={(e) => { internalNavigate(e) }}
            className={teaserClassName}
          >
            <div className="teaser-image">
              <span className="kick__v100-gameCell__team">
                  <div className="kick__v100-gameCell__team__logo">
                    {imageHomeUrl && <Image src={imageHomeUrl} alt="Logo" width="152" height="152" className="kick__flag-shadow" />}
                  </div>
                </span>
              <span className="kick__v100-gameCell__team">
                  <div className="kick__v100-gameCell__team__logo">
                    {imageAwayUrl && <Image src={imageAwayUrl} alt="Logo" width="152" height="152" className="kick__flag-shadow" />}
                  </div>
                </span>
              
            </div>
          <div className="teaser-body">
        
        <TeaserInfos teaser={teaser} />

        {teaser.title && <h3 className="teaser-title">{teaser.title}</h3>}

        {data.ignoreLead != true && teaser.lead && <p className="teaser-lead">{teaser.lead}</p>}

        {(teaser.subline || authorNames) &&
          <div className="teaser-meta">
            <span className="teaser-author">
              { authorNames && `Von ${authorNames}` }
            </span>
            <span className="teaser-date">
              {teaser.subline}
            </span>
          </div>
        }
      </div>
          </a>
        </div>
      
      
    </div>
  )
}

export default TeaserKickerLiveTicker
